import { render, staticRenderFns } from "./AppointmentCard.vue?vue&type=template&id=e00163ba&"
import script from "./AppointmentCard.vue?vue&type=script&lang=js&"
export * from "./AppointmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports